import React from 'react';
import { Card, CardBody } from 'lunchbox';
import { SIDEBAR_FEATURE_CONSTANT } from '../../data/constant';

const SidebarFeatureItems = ({ featureItems }) =>
  (
    <div>
      {featureItems.map((item) =>
        (
          <div key={item.featureTitle} className="my-2.5 flex sidebar-features__item">
            <div className="mr-8 self-center sidebar-features__item-icon">
              <i className="overflow-hidden relative iconSprites iconSprites-checkmark-circle-outline" />
            </div>
            <div className="flex flex-col sidebar-features__item-text">
              <span className="text-sm font-semibold">
                {item.featureTitle}
              </span>
              <span className="text-sm text-lp-gray-10">
                {item.featureContent}
              </span>
            </div>
          </div>
        ))}
    </div>
  );
const SidebarFeature = () =>
  (
    <div className="sidebar__feature md-max:mx-2.5">
      <Card>
        <CardBody>
          <SidebarFeatureItems featureItems={SIDEBAR_FEATURE_CONSTANT} />
        </CardBody>
      </Card>
    </div>
  );
export default SidebarFeature;
